import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';
import { controlClass } from './control';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: LucideIcon;
  suffix?: React.ReactNode;
  mono?: boolean;
}

export function Input({ icon: Icon, suffix, mono, className, ...props }: InputProps) {
  const control = (
    <input
      className={cn(
        controlClass,
        'h-10 px-3',
        Icon && 'pl-9',
        suffix && 'pr-10',
        mono && 'font-tabular',
        className
      )}
      {...props}
    />
  );

  if (!Icon && !suffix) return control;

  return (
    <div className="relative">
      {Icon && (
        <Icon
          className="pointer-events-none absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-fg-faint"
          aria-hidden="true"
        />
      )}
      {control}
      {suffix && <div className="absolute top-1/2 right-2 -translate-y-1/2">{suffix}</div>}
    </div>
  );
}

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cn(controlClass, 'min-h-24 px-3 py-2 leading-relaxed', className)} {...props} />;
}
